import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import RangeTypeForm from '../../../components/forms/RangeTypeForm';
import { useRangeTypeById, useUpdateRangeType } from '../../../hooks/useRangeTypeApi';
import { useNavigate, useParams } from 'react-router-dom';

const RangeTypeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData } = useRangeTypeById(id);
  const updateMutation = useUpdateRangeType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Range Types', href: '/admin/rangetypes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/rangetypes');
    } catch (error) {
      console.error('Error updating RangeType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/rangetypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.RangeType.Edit"
    >
      {entityData ? (
        <RangeTypeForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/rangetypes')}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default RangeTypeEdit;
